// Dashboard Action Types
export const FETCH_DASHBOARD_DATA_REQUEST = "FETCH_DASHBOARD_DATA_REQUEST";
export const FETCH_DASHBOARD_DATA_SUCCESS = "FETCH_DASHBOARD_DATA_SUCCESS";
export const FETCH_DASHBOARD_DATA_FAILURE = "FETCH_DASHBOARD_DATA_FAILURE";

export const FETCH_CCM_DASHBOARD_DATA_REQUEST = "FETCH_CCM_DASHBOARD_DATA_REQUEST";
export const FETCH_CCM_DASHBOARD_DATA_SUCCESS = "FETCH_CCM_DASHBOARD_DATA_SUCCESS";
export const FETCH_CCM_DASHBOARD_DATA_FAILURE = "FETCH_CCM_DASHBOARD_DATA_FAILURE";

export const FETCH_EXTENSION_REQUESTS_REQUEST = "FETCH_EXTENSION_REQUESTS_REQUEST";
export const FETCH_EXTENSION_REQUESTS_SUCCESS = "FETCH_EXTENSION_REQUESTS_SUCCESS";
export const FETCH_EXTENSION_REQUESTS_FAILURE = "FETCH_EXTENSION_REQUESTS_FAILURE";

export const FETCH_PENDING_ERRORS_REQUEST = "FETCH_PENDING_ERRORS_REQUEST";
export const FETCH_PENDING_ERRORS_SUCCESS = "FETCH_PENDING_ERRORS_SUCCESS";
export const FETCH_PENDING_ERRORS_FAILURE = "FETCH_PENDING_ERRORS_FAILURE";

export const FETCH_PENDING_BP_CHECK_REQUEST = "FETCH_PENDING_BP_CHECK_REQUEST";
export const FETCH_PENDING_BP_CHECK_SUCCESS = "FETCH_PENDING_BP_CHECK_SUCCESS";
export const FETCH_PENDING_BP_CHECK_FAILURE = "FETCH_PENDING_BP_CHECK_FAILURE";

export const CLEAR_DASHBOARD_ERROR = "CLEAR_DASHBOARD_ERROR";
export const RESET_DASHBOARD = "RESET_DASHBOARD";

// Dealer Trends Action Types
export const SET_DEALER_TRENDS_PERIOD = "SET_DEALER_TRENDS_PERIOD";
export const SET_DEALER_TRENDS_VIEW = "SET_DEALER_TRENDS_VIEW";
export const SET_SELECTED_DEALERS = "SET_SELECTED_DEALERS";
export const ADD_DEALERS = "ADD_DEALERS";
export const REMOVE_DEALER = "REMOVE_DEALER";
export const CLEAR_SELECTED_DEALERS = "CLEAR_SELECTED_DEALERS";

// Export excel Action Types
export const EXPORT_EXCEL_REQUEST = "EXPORT_EXCEL_REQUEST";
export const CLEAR_EXCEL = "CLEAR_EXCEL";
